module.exports = __webpack_public_path__ + "img/intelligent-m3.81a04bab.png";